import { useToggleable } from '@stores/toggleables';
import { POST_CLASS_RECOMMENDATION_DIALOG } from '@constants/toggleables';
import create from 'zustand';

interface contentType {
  goalUID: string;
  classUID: string;
  is5minSV: boolean;
}

interface storeType {
  content: contentType;
  setContent: (content: contentType) => void;
}

const useStore = create<storeType>((set) => ({
  content: null,
  setContent: (content) => set({ content })
}));

interface useToggleableType {
  isOpen: boolean;
  openElement: () => {};
  closeElement: () => {};
}

export default function usePostClassRecommendation() {
  const { isOpen, openElement, closeElement } = useToggleable(
    POST_CLASS_RECOMMENDATION_DIALOG
  ) as useToggleableType;

  const data = useStore((state) => state.content);
  const setContent = useStore((state) => state.setContent);

  function open(goalUID: string, classUID: string, is5minSV: boolean) {
    setContent({ goalUID, classUID, is5minSV: is5minSV ?? true });
    openElement();
  }

  function close() {
    setContent(null);
    closeElement();
  }

  return {
    isOpen,
    data,
    open,
    close
  };
}
